import React from 'react';
import PropTypes from 'prop-types';
import { Visible } from '@tfecom-thermofisher/react-komodo-design';

import { Icon } from 'src/core/components';

import { getCircleClassNames } from './helpers';

const Circle = ({
  topContent,
  leftContent,
  hasBottomBorder,
  hasRightBorder,
  well,
  onClick,
  condensed,
}) => {
  const borderConfig = {
    top: !!topContent,
    left: !!leftContent,
    bottom: hasBottomBorder,
    right: hasRightBorder,
  };
  const classNames = getCircleClassNames(well, borderConfig, condensed);
  const circleCommonProps = {
    className: classNames.circle,
    onClick: () => onClick(well),
  };

  const circle = well.isValid === null || well.isValid ? (
    <div {...circleCommonProps} />
  ) : (
    <Icon
      name="alert-bold"
      size={24}
      color="red"
      {...circleCommonProps}
    />
  );

  return (
    <div className="wells-circle__content-wrapper--top" data-testid="circle-valid">
      <Visible when={!!topContent}>
        <div className="content-wrapper--top">
          {topContent}
        </div>
      </Visible>
      <div className="wells-circle__content-wrapper--left">
        <Visible when={!!leftContent}>
          <div className="content-wrapper--left">
            {leftContent}
          </div>
        </Visible>
        <div className={classNames.wrapper}>
          {circle}
        </div>
      </div>
    </div>
  );
};

Circle.propTypes = {
  well: PropTypes.object,
  onClick: PropTypes.func.isRequired,
  topContent: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  leftContent: PropTypes.string,
  hasBottomBorder: PropTypes.bool.isRequired,
  hasRightBorder: PropTypes.bool.isRequired,
  condensed: PropTypes.bool,
};

export default Circle;
